<template>
  <div :id="id" class="com-rank" :style="{height}" />
</template>

<script>
import * as echarts from 'echarts/lib/echarts'

export default {
  name: 'barChart',
  props: {
    id: {
      type: String,
      default: () => 'lineChart'
    },
    xDataOptions: {
      type: Array,
      default: () => []
    },
    yDataOptions: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: () => '300px'
    }
  },
  data () {
    return {
      myEchart: null
    }
  },
  watch: {
    xDataOptions (val) {
      if (val) {
        this.$nextTick(() => {
          this.initChart()
        })
      }
    },
    yDataOptions (val) {
      if (val) {
        this.$nextTick(() => {
          this.initChart()
        })
      }
    },
    deep: true
  },
  mounted () {
    // 监测视口大小
    window.addEventListener('resize', () => {
      setTimeout(() => {
        this.myEchart && this.myEchart.resize()
      }, 800)
    })
    this.initChart()
  },
  beforeDestroy () {
    this.myEchart && echarts.dispose(this.myEchart)
    this.myEchart = null
  },
  methods: {
    initChart () {
      this.myEchart = this.$echarts.init(document.getElementById(this.id))
      const xData = this.xDataOptions
      const yData = this.yDataOptions
      this.myEchart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
            type: 'value'
          }],
        yAxis: [{
          type: 'category',
          axisTick: {
            show: false
          },
          data: xData
        }],
        series: [
            {
              name: '企业行业分布',
              type: 'bar',
              label: {
                show: false,
                position: 'inside'
              },
              emphasis: {
                focus: 'series'
              },
              data: yData
            }
          ]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.com-rank {
  // height: 300px;
  background-color: #fff !important;
}
</style>
